import React from "react";
import MulContentUs from "../components/mulecules/content-us/mul-content-us";

function ContentUsMobile() {
    return(
        <MulContentUs/>
    )
}

export default ContentUsMobile;